$(function () {
    'use strict';

    /*------ MENU Fixed ------*/
    $(window).scroll(function () {
        var $scroll = $(window).scrollTop();
        var $navbar = $('.navbar');
        var $header = $('#header ');
        if ($scroll > 10) {
            $navbar.addClass('scroll-nav');
            $header.addClass('bar-color');
        } else {
            $navbar.removeClass('scroll-nav');
            $header.removeClass('bar-color');
        }
    });
    $('.product-slider').owlCarousel({
        loop: true,
        margin: 16,
        nav: false,
        arrow: false,
        center: true,
        autoplay: true,
        autoplayTimeout: 4000,
        slideSpeed: 1000,
        smartSpeed: 1000,
        dots: false,
        responsive: {
            0: {
                items: 1.3,
            },
            767: {
                items: 2.1,
            },
            1024: {
                items: 3,
            },
            1280: {
                items: 4,
            },
        },
    });

    $('.flowors-slider').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        center: true,
        autoplay: false,
        autoplayTimeout: 4000,
        slideSpeed: 500,
        smartSpeed: 500,
        dots: false,

        responsive: {
            0: {
                items: 1,
                center: true,
                nav: true,
                navText: ['<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/left1.svg?v=1752058431" />', '<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/right1.svg?v=1752058431" alt="Next" />'],
            },
            600: {
                items: 3,
            },
            1000: {
                items: 5,
            },
        },
    });

    $(document).ready(function () {
        // Initialize Owl Carousel
        $('.logo-slider').owlCarousel({
            loop: true,
            margin: 10,
            nav: false,
            autoplay: true,
            autoplayTimeout: 2000,
            autoplayHoverPause: true,
            slideSpeed: 500,
            smartSpeed: 500,
            dots: false,
            responsive: {
                0: {
                    items: 3,
                },
                600: {
                    items: 4,
                },
                1000: {
                    items: 6,
                },
            },
            onInitialized: updateDrinkTitle, // Update on init
        });

        // Update title on slide change
        $('.logo-slider').on('changed.owl.carousel', function (event) {
            updateDrinkTitle(event);
        });

        // Function to update drink title
        function updateDrinkTitle(event) {
            var $slider = $('.logo-slider');
            var currentIndex = event && event.item ? event.item.index : 0;

            var $currentItem = $slider.find('.owl-item').eq(currentIndex).find('.item');

            var text = $currentItem.data('text') || '';
            $('.index_drinkBox').text(text);
        }
    });

    $('.product-new').owlCarousel({
        loop: true,
        margin: 0,
        dots: false,
        nav: true,
        navText: ['<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/left1.svg?v=1752058431" />', '<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/right1.svg?v=1752058431" alt="Next" />'],

        responsive: {
            0: {
                items: 1.3,
                center: true,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 4,
            },
        },
    });

    $('.beverages-slider').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 4000,
        slideSpeed: 800,
        smartSpeed: 800,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 2.8,
            },
        },
    });
    $('.shop-slider').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        navText: ['<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/left-arrows.svg" alt="Previous" />', '<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/right-arrows.svg" alt="Next" />'],
        responsive: {
            0: {
                items: 2,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 2.9,
            },
        },
    });
    $('.catagory-slider').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1.2,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 4,
            },
        },
    });

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.matchMedia({
        // Desktop only
        '(min-width: 1025px)': function () {
            gsap.to('.slide-icon', {
                y: 750,
                opacity: 0, // fade out while sliding
                duration: 30,
                scrollTrigger: {
                    trigger: '.best-drink',
                    start: 'top 60%',
                    end: 'bottom top',
                    scrub: 2,
                    toggleActions: 'play none none none',
                    markers: false,
                },
            });

            gsap.to('.national-list ul li:nth-child(1)', {
                y: 300,
                duration: 30,
                scrollTrigger: {
                    trigger: '.national',
                    start: 'top center',
                    end: 'bottom bottom',
                    scrub: 1,
                    toggleActions: 'play none none none',
                    markers: false,
                },
            });

            gsap.to('.national-list ul li:nth-child(2)', {
                y: -300,
                duration: 30,
                scrollTrigger: {
                    trigger: '.national',
                    start: 'top center',
                    end: 'bottom bottom',
                    scrub: 1,
                    toggleActions: 'play none none none',
                    markers: false,
                },
            });

            gsap.to('.retail-list ul li:nth-child(1)', {
                y: 70,
                opacity: 0,
                duration: 30,
                scrollTrigger: {
                    trigger: '.retail-partner',
                    start: 'top center',
                    end: 'bottom bottom',
                    scrub: 1,
                    toggleActions: 'play none none none',
                    markers: false,
                },
            });

            gsap.to('.retail-list ul li:nth-child(4)', {
                y: -70,
                opacity: 0,
                duration: 30,
                scrollTrigger: {
                    trigger: '.retail-partner',
                    start: '40% center',
                    end: 'bottom bottom',
                    scrub: 1,
                    toggleActions: 'play none none none',
                    markers: false,
                },
            });
        }, // end desktop condition
    });
    gsap.to('.plane', {
        x: 1200,

        duration: 10,
        scrollTrigger: {
            trigger: '.contact-us-section',
            start: '40% center',
            end: 'bottom bottom',
            scrub: 1,
            toggleActions: 'play none none none',
            markers: false,
        },
    });

    $('.question').click(function () {
        $(this).siblings('.answer').slideToggle().parent().siblings().children('.answer').slideUp();

        $(this).toggleClass('active').parent().siblings().children('h6').removeClass('active');
        if ($(this).hasClass('active')) {
            $(this).parent('.your-question').addClass('active');
        } else {
            $(this).parent('.your-question').removeClass('active');
        }
    });

    $(document).ready(function () {
        $('.headerHamburger button').click(function () {
            $(this).toggleClass('active');
            $('#nav').toggleClass('active');
            $('.headerMobileOverlay').toggleClass('active');
            if ($(this).hasClass('active')) {
                $('html').addClass('overflow');
            } else {
                $('html').removeClass('overflow');
            }
        });
    });

    $(document).ready(function () {
        $('.modal-link').on('click', function () {
            $('body').addClass('modal-open');
        });
        $('.close-modal').on('click', function () {
            $('body').removeClass('modal-open');
        });
    });
});

// hassaan script

// sub menu tabbing

$(document).ready(function () {
    const isDesktop = window.innerWidth > 992;

    // ✅ Desktop hover tabs
    if (isDesktop) {
        $('.mega-sub-tabs ul li').first().addClass('mega-tab-active');
        $('.mega-tab-content').first().addClass('active').css('display', 'flex');

        $('.mega-sub-tabs ul li').on('mouseenter', function () {
            const tab_id = $(this).attr('data-tab');
            const $this = $(this);
            const $currentContent = $('#' + tab_id);

            if ($this.hasClass('mega-tab-active') && $currentContent.hasClass('active')) return;

            $('.mega-sub-tabs ul li').removeClass('mega-tab-active');
            $this.addClass('mega-tab-active');

            $('.mega-tab-content.active').removeClass('active').hide();
            $currentContent.css('display', 'flex').addClass('active');
        });
    } else {
        // ✅ Remove <a> from mobile tabs
        $('.mega-sub-tabs ul li').each(function () {
            const text = $(this).find('a').text();
            $(this).html(`${text} <img src="https://testing-local-cp.myshopify.com/cdn/shop/t/8/assets/go.svg" alt="#">`);
        });

        $('.mega-tab-content').hide();

        // ✅ Automatically open first main nav item with mega-sub-menu
        const $firstMegaMenuLi = $('.navbar ul > li').has('.mega-sub-menu').first();
        const $firstMegaMenu = $firstMegaMenuLi.find('.mega-sub-menu');
        const $firstSubMenu = $firstMegaMenuLi.find('ul.sub-menu');

        $firstMegaMenu.addClass('show');

        if ($firstSubMenu.length) {
            $firstSubMenu.attr('style', 'display: block !important;');
        }

        // ✅ Mobile tab click toggle
        $('.mega-sub-tabs ul li').on('click', function () {
            const tab_id = $(this).attr('data-tab');
            const $this = $(this);
            const $currentContent = $('#' + tab_id);
            const isActive = $this.hasClass('mega-tab-active');

            if (isActive) {
                $this.removeClass('mega-tab-active');
                $currentContent.removeClass('active').hide();
            } else {
                $('.mega-sub-tabs ul li').removeClass('mega-tab-active');
                $('.mega-tab-content').removeClass('active').hide();

                $this.addClass('mega-tab-active');
                $this.after($currentContent);
                $currentContent.css('display', 'flex').addClass('active');
            }
        });
    }

    // ✅ Mobile nav menu dropdown logic
    $('.navbar ul li > img').click(function (e) {
        // Prevent inside mega-sub-menu toggle
        if ($(e.target).closest('.mega-sub-menu').length) return;

        if (window.innerWidth <= 992) {
            e.preventDefault();
            e.stopPropagation();

            const $parentLi = $(this).closest('li');
            const $megaMenu = $parentLi.find('.mega-sub-menu');
            const $subMenu = $parentLi.find('ul.sub-menu');

            // Hide others
            $('.mega-sub-menu').not($megaMenu).removeClass('show');
            $('ul.sub-menu').not($subMenu).attr('style', 'display: none !important;');

            // Toggle current mega menu
            if ($megaMenu.length) {
                $megaMenu.toggleClass('show');
            }

            // Toggle current sub-menu
            if ($subMenu.length) {
                const isVisible = $subMenu[0].style.display === 'block';
                if (isVisible) {
                    $subMenu.attr('style', 'display: none !important;');
                } else {
                    $subMenu.attr('style', 'display: block !important;');
                }
            }
        }
    });
});

// new hassaan script 26 june 2025

$(document).ready(function () {
    $('.QA-content:first .answer').slideDown();
    $('.QA-content:first').addClass('answer-active');
    $('.QA-content:first .Question').addClass('question-active');
    $('.QA-content:first .Question img').attr('src', 'https://cdn.shopify.com/s/files/1/0808/3747/6386/files/minus.svg');

    $('.Question').click(function () {
        var $qaContent = $(this).closest('.QA-content');
        var $answer = $qaContent.find('.answer');
        var $icon = $(this).find('img');

        $('.answer').not($answer).slideUp();
        $('.QA-content').not($qaContent).removeClass('answer-active');
        $('.Question').not(this).removeClass('question-active').find('img').attr('src', 'https://cdn.shopify.com/s/files/1/0808/3747/6386/files/plus.svg');

        $answer.slideToggle();
        $qaContent.toggleClass('answer-active');
        $(this).toggleClass('question-active');

        if ($qaContent.hasClass('answer-active')) {
            $icon.attr('src', 'https://cdn.shopify.com/s/files/1/0808/3747/6386/files/minus.svg');
        } else {
            $icon.attr('src', 'https://cdn.shopify.com/s/files/1/0808/3747/6386/files/plus.svg');
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const marquees = document.querySelectorAll('.circular-marquee');

    marquees.forEach((wrapper) => {
        const track = wrapper.querySelector('.circular-track');
        const reverse = wrapper.classList.contains('reverse');
        const isMobile = window.innerWidth <= 768;
        const baseSpeed = isMobile ? 0.3 : 1;
        const reverseMultiplier = 0.3;
        const speed = reverse ? baseSpeed * reverseMultiplier : baseSpeed;

        let posX = 0;

        // ✅ Clone all items to avoid visual gap
        const items = Array.from(track.children);
        items.forEach((item) => {
            const clone = item.cloneNode(true);
            track.appendChild(clone);
        });

        function loop() {
            posX += reverse ? speed : -speed;
            track.style.transform = `translateX(${posX}px)`;

            const totalWidth = track.scrollWidth / 2;

            // Reset position to loop seamlessly
            if (!reverse && Math.abs(posX) >= totalWidth) {
                posX = 0;
            } else if (reverse && posX >= 0) {
                posX = -totalWidth;
            }

            requestAnimationFrame(loop);
        }

        loop();
    });
});

$(document).ready(function () {
    $('.list-cntnnt h4').on('click', function () {
        const $this = $(this);

        // Close others
        $('.list-cntnnt h4').not($this).removeClass('active').next('p').slideUp();

        // Toggle current
        $this.toggleClass('active');
        $this.next('p').slideToggle();
    });
});

(function ($) {
    $(document).ready(function () {
        function readyFn() {
            const space = $('.empty-div,.heading-beliefs,.all-tags').position()?.left || 0;
            console.log(space);
            //   $('.farmer-flex, .beliefs-slider, .collection-slider-section').css('padding-left', space);
        }

        $(window).on('load resize', readyFn);
    });
})(jQuery);

// Customer Slider 10 July
var isMobile = window.innerWidth < 768; // Adjust breakpoint if needed

$('.customer-slider').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    autoWidth: true,
    mouseDrag: isMobile, // Mouse drag only on mobile
    touchDrag: true, // Touch drag remains enabled

    responsive: {
        0: {
            items: 1,
            autoWidth: false,
            dots: false,
            margin: 15,
            nav: true,
            navText: ['<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/left1.svg?v=1752058431" />', '<img src="https://cdn.shopify.com/s/files/1/0808/3747/6386/files/right1.svg?v=1752058431" alt="Next" />'],
        },
        600: {
            items: 3,
        },
        1000: {
            items: 3,
        },
    },
});

function scrollSlider(direction) {
    const slider = document.getElementById('customSlider');
    const scrollAmount = slider.offsetWidth * 0.9;

    if (direction === 'left') {
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
}

// Target the element to observe
